<div *ngIf="processing" class="process-info-message">
    <img src="../assets/img/spinner.svg"><strong>{{message}}</strong>
</div>